module.exports = __webpack_public_path__ + "img/12.cf515570.png";